module.exports = __webpack_public_path__ + "img/bg-3@xs.51c9ad1e.jpg";